import Vue from 'vue';

export const maxCellIdStore = Vue.observable({
    maxCellId: 0,
    setCount(value) {
        this.maxCellId = value;
    },
    increment() {
        this.maxCellId++;
    },
});
